import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import { useNavigate } from "react-router-dom";
import { QuestionCategoryFormikObj, questionnaireForOptions } from "./Constant";
import { Skeleton, Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { createQuestionCategory } from "../../api/Questionnaire";
import { useQuestionQuery } from "../../../hooks/ReactQueryHooks/useQuestionQuery";
import { useSelector } from "react-redux";
import { getOrganization } from "../../api/Organization";

const CreateCategory = () => {
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const userOrg = useSelector((state) => state?.auth?.user?.["custom:orgId"]);
  const isSuperAdmin = Array.isArray(userRoles) && userRoles.includes("Super-Admin");

  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [orgsLoading, setOrgsLoading] = useState(true);

  // Preload questions (your existing hook)
  const { isLoading, isFetching } = useQuestionQuery({ orgId: userOrg, onSuccess: () => {} });

  // Load organizations for the dropdown
  useEffect(() => {
    (async () => {
      try {
        const res = await getOrganization();
        const opts = (res?.data || []).map((o) => {
          const id = o.id ?? o.orgId;
          const name = o.name ?? o.orgName;
          return { id, name, value: id, label: name }; 
        });
        setOrganizations(opts);
      } catch (e) {
        // ignore
      } finally {
        setOrgsLoading(false);
      }
    })();
  }, []);

  const formik = useFormik({
    ...QuestionCategoryFormikObj,
    // ensure orgId is present in the payload
    initialValues: {
      ...(QuestionCategoryFormikObj.initialValues || {}),
      orgId: userOrg || "",
    },
    onSubmit: (values) => {
      values.categoryName = values.categoryName?.trim();
      setBtnLoading(true);
      createQuestionCategory({ ...values })
        .then((res) => {
          navigate("/app/manage-category");
          success(res.message);
        })
        .catch((res) =>
          failed(res?.response?.data?.message || res?.response?.data?.error || res.message)
        )
        .finally(() => setBtnLoading(false));
    },
  });

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        <Tooltip title="Go back">
          <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
            <ArrowBack />
          </div>
        </Tooltip>
      </div>

      <div className="custom-card p-4">
        <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
          <Row className="mt-3">
            <Col>
              {orgsLoading ? (
                <div>
                  <div style={{ marginBottom: 6 }}>Organization</div>
                  <Skeleton height={40} />
                </div>
              ) : (
                <SearchSelect
                  keyField={"orgId"}
                  label={"Organization"}
                  formik={formik}
                  placeholder={"Select Organization"}
                  options={(true ? organizations : organizations.filter((o) => (o.id ?? o.value) === userOrg)).map((o) => ({
                    label: o.name ?? o.label,
                    value: o.value ?? o.id,
                  }))}
                  value={organizations.find((o) => (o.value ?? o.id) === formik.values.orgId) || null}
                  isClearable={false}
                  onChange={(selected) => formik.setFieldValue("orgId", selected?.value || "")}
                  required={true}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                keyField={"categoryName"}
                label={"Category Name"}
                formik={formik}
                placeholder={"Category Name"}
              />
            </Col>

            <Col>
              <SelectFiled
                keyField={"categoryType"}
                label={"Workflow"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireForOptions}
              />
            </Col>
          </Row>

          <div className="btn-wrap" style={{ display: "flex", marginTop: "2rem" }}>
            <Button variant="secondary" title="Cancel" onClick={() => navigate("/app/manage-category")}>
              Cancel
            </Button>
            <Button type="submit" isLoading={btnLoading} disabled={isLoading || isFetching}>
              Create
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CreateCategory;